var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn bxs",class:[
        'btn-' + _vm.background,
        'btn-' + _vm.size
    ],attrs:{"href":_vm.getRedirectUrl(),"target":"_blank"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }